/**
 * 一覧のページ送り（「さらに読み込む」）の React に依存しない部分（2026-10-04 console/limits-ui）。
 * フックは hooks.ts の usePagedResource、ボタンは components/LoadMore.tsx。
 *
 * WHY 足したか: 画面の一覧がリーダーボード 50・デプロイ履歴 20・前払いの明細 30・払い出し 20・申し立て 200 で切れていて、
 *   それより先が見えなかった（洗い出し docs/quality/limits-audit-2026-10-04.md の L110 と「画面の一覧にページ送りなし」）。
 *   サーバーは cursor / nextCursor（null = もう無い）で次のページを返す。形は PlayersPage の「さらに読み込む」と同じ。
 * WHY 別ファイルか: node --test（型を剥がすだけ）で確かめられるように、JSX と React を持ち込まない。
 */

/** path に cursor を足す。cursor は中身を解釈しない（サーバーが決める文字列）= そのままエンコードして返す */
export function withCursor(path: string, cursor: string): string {
  return `${path}${path.includes('?') ? '&' : '?'}cursor=${encodeURIComponent(cursor)}`;
}

/** 最初のページの応答に、後から読んだ行（extra）を key の一覧の後ろに足す。total などほかの値は最初のページのまま */
export function mergePages<T extends object, K extends keyof T>(first: T | null, key: K, extra: unknown[]): T | null {
  if (!first || extra.length === 0) return first;
  return { ...first, [key]: [...((first[key] as unknown[]) ?? []), ...extra] };
}
